// Chargement après DOM ready
document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get('product-options-selector')) {
    customElements.define('product-options-selector', ProductOptionsSelector);
  }
});

class ProductOptionsSelector extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.mainFormId = this.dataset.mainFormId;
    this.isDualLists = this.dataset.dualLists === 'true';
    
    this.optionsData = null;
    this.currentList1Selection = null;
    this.currentList2Selection = null;
    this.mainProductPrice = 0;
    
    this.init();
  }

  connectedCallback() {
     window.optionsScriptActive = true;
      this.setupEventListeners();
  }

  init() {
    // Charger les données des options
    const dataScript = this.querySelector('.product-options-data');
    if (dataScript) {
      this.optionsData = JSON.parse(dataScript.textContent);
      this.mainProductPrice = this.optionsData.mainProductPrice;
    }

    // Sélectionner les options de base par défaut
    if (this.isDualLists) {
      this.currentList1Selection = 'list1-base';
      this.currentList2Selection = 'list2-base';
      
      // Vérifier et pré-sélectionner les options de base
      const list1BaseInput = this.querySelector('input[value="list1-base"]');
      const list2BaseInput = this.querySelector('input[value="list2-base"]');
      
      if (list1BaseInput) list1BaseInput.checked = true;
      if (list2BaseInput) list2BaseInput.checked = true;
    }
  }
  

  getCurrentVariantPrice() {
  // Méthode 1 : Via le script JSON de variante
  const variantScript = document.querySelector('script[data-variant]');
  if (variantScript) {
    try {
      const variantData = JSON.parse(variantScript.textContent);
      return variantData.price || this.mainProductPrice;
    } catch (error) {
      console.warn('Erreur lecture prix variante:', error);
    }
  }
  
  // Méthode 2 : Via l'input hidden
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput && variantInput.value) {
    // Chercher dans les données produit si disponibles
    if (this.optionsData && this.optionsData.variants) {
      const variant = this.optionsData.variants.find(v => v.id == variantInput.value);
      if (variant) return variant.price;
    }
  }
  
  return this.mainProductPrice;
}
  
  setupEventListeners() {
    // Écouter les changements de sélection d'options
    this.querySelectorAll('.product-option-item__input').forEach(input => {
      input.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.handleOptionChange(e.target);
        }
      });
    });

    // Écouter les clics sur les conteneurs d'options
    this.querySelectorAll('.product-option-item').forEach(item => {
      item.addEventListener('click', (e) => {
        // Ne pas déclencher si on a cliqué directement sur le radio button
        if (e.target.type === 'radio') return;
        
        const input = item.querySelector('.product-option-item__input');
        if (input && !input.checked) {
          input.checked = true;
          this.handleOptionChange(input);
        }
      });
    });

    // Bouton fiches détaillées
    const detailsBtn = this.querySelector('.product-options__details-btn');
    if (detailsBtn) {
      detailsBtn.addEventListener('click', () => {
        this.handleDetailsClick();
      });
    }

    // Écouter les soumissions du formulaire principal
    this.listenToMainForm();

    this.setupVariantListeners();
  }

  handleOptionChange(input) {
  const selectedValue = input.value;
  const listNumber = input.dataset.list;
  const productHandle = input.dataset.productHandle;
    const variantHandle = input.dataset.variantHandle;
  const variantTitle = input.dataset.variantTitle;  
  const productPrice = parseInt(input.dataset.productPrice || '0');
  const productTitle = input.dataset.productTitle;
  
  // Mettre à jour la sélection selon la liste
  if (listNumber === '1') {
    this.currentList1Selection = selectedValue;
  } else if (listNumber === '2') {
    this.currentList2Selection = selectedValue;
  }
  
  // Mettre à jour l'affichage
  this.updateSelection(selectedValue, listNumber);
  
  // Mettre à jour les champs cachés
  this.updateHiddenInputs(productTitle, listNumber);
  
  // Mettre à jour le prix total
  this.updateTotalPrice();
  
  // Mettre à jour le bouton fiches détaillées
  this.updateDetailsButton();
  
  // NOUVEAU: Mettre à jour l'image du produit
 const variants = this.getSelectedVariants();
const combinedHandle = this.getCombinedHandle();


// NOUVEAU: Mettre à jour l'image du produit
this.updateProductImage(selectedValue, combinedHandle);


// Émettre un événement personnalisé
this.dispatchEvent(new CustomEvent('option-changed', {
  detail: {
    selectedValue,
    listNumber,
    productHandle,
    variantHandle,      
    variantTitle,  
    productPrice,
    productTitle,
    list1Selection: this.currentList1Selection,
    list2Selection: this.currentList2Selection,
    totalPrice: this.calculateTotalPrice(),
    combinedHandle: combinedHandle,
    variants: variants
  },
  bubbles: true
}));
}

  updateSelection(selectedValue, listNumber) {
    // Retirer la classe selected des éléments de la liste concernée
    const listContainer = this.querySelector(`[data-list="${listNumber}"]`);
    if (listContainer) {
      listContainer.querySelectorAll('.product-option-item').forEach(item => {
        item.classList.remove('product-option-item--selected');
      });
    }
    
    // Ajouter la classe selected à l'élément sélectionné
    const selectedItem = this.querySelector(`[data-option-id="${selectedValue}"]`);
    if (selectedItem) {
      selectedItem.classList.add('product-option-item--selected');
      
      // Animation subtile
      // selectedItem.style.transform = 'scale(1.02)';
      // setTimeout(() => {
      //   selectedItem.style.transform = '';
      // }, 200);
    }
  }

  updateHiddenInputs(productTitle, listNumber) {
    if (listNumber === '1') {
      const list1Input = this.querySelector('.product-options__selected-list1');
      if (list1Input) list1Input.value = productTitle;
    } else if (listNumber === '2') {
      const list2Input = this.querySelector('.product-options__selected-list2');
      if (list2Input) list2Input.value = productTitle;
    }
  }

  calculateTotalPrice() {
  // ✅ Utiliser le prix de la variante actuelle au lieu du prix fixe
  let totalPrice = this.getCurrentVariantPrice();
  
  // Ajouter le prix des options...
  if (this.currentList1Selection && this.currentList1Selection !== 'list1-base') {
    const list1Input = this.querySelector(`input[value="${this.currentList1Selection}"]`);
    if (list1Input) {
      totalPrice += parseInt(list1Input.dataset.productPrice || '0');
    }
  }
  
  if (this.currentList2Selection && this.currentList2Selection !== 'list2-base') {
    const list2Input = this.querySelector(`input[value="${this.currentList2Selection}"]`);
    if (list2Input) {
      totalPrice += parseInt(list2Input.dataset.productPrice || '0');
    }
  }
  
  return totalPrice;
}

  updateTotalPrice() {
    const totalPrice = this.calculateTotalPrice();
    const priceElements = document.querySelectorAll('.product .price-list .price:not(.price--compare)');
    
    priceElements.forEach((priceEl) => {
      const formattedPrice = this.formatPrice(totalPrice);
      
      // Conserver la structure originale avec le span visually-hidden
      const visuallyHidden = priceEl.querySelector('.visually-hidden');
      const hiddenText = visuallyHidden ? visuallyHidden.outerHTML : '<span class="visually-hidden">Prix de vente</span>';
      
      priceEl.innerHTML = hiddenText + formattedPrice;
    });

    // Mettre à jour le prix dans le sticky add to cart si présent
    const stickyPrice = document.querySelector('.product-sticky-form .price');
    if (stickyPrice) {
      stickyPrice.innerHTML = this.formatPrice(totalPrice);
    }
    
    // Émettre un événement pour d'autres scripts qui pourraient écouter
    document.dispatchEvent(new CustomEvent('product:price-updated', {
      detail: { newPrice: totalPrice, formattedPrice: this.formatPrice(totalPrice) }
    }));
  }

  formatPrice(priceInCents) {
    if (!this.optionsData) return priceInCents;
    
    const { moneyFormat, moneyWithCurrencyFormat, currencyCodeEnabled } = this.optionsData;
    const format = currencyCodeEnabled ? moneyWithCurrencyFormat : moneyFormat;
    const priceInEuros = (priceInCents / 100).toFixed(2);
    
    let formattedPrice = format;
    
    if (format.includes('{{amount_with_comma_separator}}')) {
      const euroFormatted = priceInEuros.replace('.', ',');
      formattedPrice = format.replace('{{amount_with_comma_separator}}', euroFormatted);
    } else if (format.includes('{{amount}}')) {
      formattedPrice = format.replace('{{amount}}', priceInEuros);
    } else {
      formattedPrice = '€' + priceInEuros.replace('.', ',');
    }
    
    return formattedPrice;
  }

  updateDetailsButton() {
    const detailsBtn = this.querySelector('.product-options__details-btn');
    if (!detailsBtn) return;
    
    // Déterminer quel produit afficher selon les sélections
    let handleToShow = '';
    
    // Priorité à la liste 2, puis liste 1
    if (this.currentList2Selection && this.currentList2Selection !== 'list2-base') {
      const list2Input = this.querySelector(`input[value="${this.currentList2Selection}"]`);
      handleToShow = list2Input?.dataset.productHandle;
    } else if (this.currentList1Selection && this.currentList1Selection !== 'list1-base') {
      const list1Input = this.querySelector(`input[value="${this.currentList1Selection}"]`);
      handleToShow = list1Input?.dataset.productHandle;
    }
    
    detailsBtn.dataset.selectedHandle = handleToShow;
    
    if (!handleToShow) {
      detailsBtn.style.opacity = '';
      detailsBtn.style.pointerEvents = '';
      detailsBtn.textContent = 'Fiches détaillées';
      
      // detailsBtn.style.opacity = '0.5';
      // detailsBtn.style.pointerEvents = 'none';
      // detailsBtn.textContent = 'Sélectionnez une option';
    } else {
      detailsBtn.style.opacity = '';
      detailsBtn.style.pointerEvents = '';
      detailsBtn.textContent = 'Fiches détaillées';
    }
  }

  handleDetailsClick() {
    const detailsBtn = this.querySelector('.product-options__details-btn');
    const selectedHandle = detailsBtn?.dataset.selectedHandle;
    
    if (selectedHandle) {
      window.open(`/products/${selectedHandle}`, '_blank');
    }
  }

  listenToMainForm() {
    const mainForm = document.getElementById(this.mainFormId);
    if (!mainForm) return;

  mainForm.addEventListener('submit', async (e) => {
  const hasNonBaseOptions = 
    (this.currentList1Selection && this.currentList1Selection !== 'list1-base') ||
    (this.currentList2Selection && this.currentList2Selection !== 'list2-base');
  
  // 🆕 VÉRIFIER AUSSI LES ACCESSOIRES
  const hasSelectedAccessories = document.querySelectorAll('.product-accessory-item__add-btn.selected').length > 0;
  
  // Intercepter si on a des options OU des accessoires
  if (hasNonBaseOptions || hasSelectedAccessories) {
    e.preventDefault();
    e.stopPropagation(); // Empêcher le script accessoires d'agir
    await this.handleFormSubmissionWithOptions(mainForm);
  }
}, { capture: true }); // 🆕 PRIORITÉ MAXIMALE


    
  }

 // Dans votre méthode handleFormSubmissionWithOptions, remplacez la section accessoires par :

async handleFormSubmissionWithOptions(mainForm) {
  try {
    const submitBtn = mainForm.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    
    if (submitBtn) {
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Ajout en cours...';
    }

    const formData = new FormData(mainForm);
    const mainProductData = Object.fromEntries(formData);
    
    const items = [];

    // 1. Produit principal
    const mainItem = {
      id: parseInt(mainProductData.id),
      quantity: parseInt(mainProductData.quantity || 1),
      properties: {
        'Options': this.getSelectedOptionsText()
      }
    };

    // 2. Option liste 1 si sélectionnée
    if (this.currentList1Selection && this.currentList1Selection !== 'list1-base') {
      const list1Input = this.querySelector(`input[value="${this.currentList1Selection}"]`);
      const variantId = list1Input?.dataset.variantId;
      
      if (variantId && !isNaN(parseInt(variantId))) {
        items.push({
          id: parseInt(variantId),
          quantity: parseInt(mainProductData.quantity || 1),
          properties: {
            'Type': 'Option - ' + (list1Input.dataset.productTitle || 'Liste 1')
          }
        });
      }
    }

    // 3. Option liste 2 si sélectionnée
    if (this.currentList2Selection && this.currentList2Selection !== 'list2-base') {
      const list2Input = this.querySelector(`input[value="${this.currentList2Selection}"]`);
      const variantId = list2Input?.dataset.variantId;
      
      if (variantId && !isNaN(parseInt(variantId))) {
        items.push({
          id: parseInt(variantId),
          quantity: parseInt(mainProductData.quantity || 1),
          properties: {
            'Type': 'Option - ' + (list2Input.dataset.productTitle || 'Liste 2')
          }
        });
      }
    }

    // 🆕 4. UTILISER LE MANAGER D'ACCESSOIRES pour récupérer les accessoires
    if (window.accessoriesManager) {
      const accessoryItems = window.accessoriesManager.getSelectedAccessoriesForOptions();
      items.push(...accessoryItems);
      
      // Ajouter les noms des accessoires au produit principal
      const accessoryNames = window.accessoriesManager.getSelectedAccessoriesNames();
      if (accessoryNames) {
        if (!mainItem.properties) mainItem.properties = {};
        mainItem.properties['Accessoires sélectionnés'] = accessoryNames;
      }
    }

    // Ajouter le produit principal en premier
    items.unshift(mainItem);

    // Validation des items
    const validItems = items.filter(item => 
      item.id && !isNaN(item.id) && item.quantity && item.quantity > 0
    );

    if (validItems.length === 0) {
      throw new Error('Aucun produit valide à ajouter');
    }

    // Ajouter au panier via l'API
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: validItems })
    });

    if (response.ok) {
      const result = await response.json();
      
      // Succès ! Reset des sélections
      if (window.accessoriesManager) {
        window.accessoriesManager.resetSelectionsFromOptions();
      }
      
      // Notification subtile
      this.showSuccessMessage(`${validItems.length} produit${validItems.length > 1 ? 's' : ''} ajouté${validItems.length > 1 ? 's' : ''} au panier`);
      
      // Mettre à jour le cart drawer
      setTimeout(async () => {
        await this.refreshCartDrawer();
      }, 300);
      
    } else {
      const errorText = await response.text();
      console.error('Cart API error:', response.status, errorText);
      throw new Error(`Erreur ${response.status}: ${errorText}`);
    }
    
  } catch (error) {
    console.error('Error in handleFormSubmissionWithOptions:', error);
    this.showErrorMessage('Une erreur est survenue. Veuillez réessayer.');
  } finally {
    // Retirer la classe loading
    const submitBtn = mainForm.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.classList.remove('loading');
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
  }
}

  async refreshCartDrawer() {
    try {
      // Récupérer le panier mis à jour
      const cartResponse = await fetch('/cart.js');
      const updatedCart = await cartResponse.json();
      
      // Déclencher les événements Shopify
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));
      
      document.documentElement.dispatchEvent(new CustomEvent('cart:changed', {
        bubbles: true,
        detail: { cart: updatedCart }
      }));
      
      // Attendre un moment puis forcer le reload
      setTimeout(async () => {
        await this.forceCartDrawerReload();
      }, 200);
      
    } catch (error) {
      console.log('Cart refresh error:', error);
    }
  }

  async forceCartDrawerReload() {
    try {
      const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      
      if (response.ok) {
        const html = await response.text();
        const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, [data-cart-drawer]');
        
        if (cartDrawer) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          let newContent = doc.querySelector('cart-drawer .cart-drawer__content');
          if (!newContent) newContent = doc.querySelector('.cart-drawer__content');
          if (!newContent) newContent = doc.querySelector('.cart-drawer__inner');
          if (!newContent) newContent = doc.querySelector('[data-cart-items]');
          
          if (newContent) {
            const currentContent = cartDrawer.querySelector('.cart-drawer__content') || 
                                 cartDrawer.querySelector('.cart-drawer__inner') || 
                                 cartDrawer.querySelector('[data-cart-items]') ||
                                 cartDrawer;
            
            currentContent.innerHTML = newContent.innerHTML;
          }
          
          if (typeof cartDrawer.load === 'function') {
            cartDrawer.load();
          }
        }
      }
    } catch (error) {
      console.error('Force reload failed:', error);
    }
    
    this.updateCartCount();
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countElements = document.querySelectorAll(
          '.cart-count, .header__cart-count, [data-cart-count], .cart-icon__count'
        );
        
        countElements.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  getSelectedOptionsText() {
    const selections = [];
    
    if (this.currentList1Selection !== 'list1-base') {
      const list1Input = this.querySelector(`input[value="${this.currentList1Selection}"]`);
      if (list1Input) {
        selections.push(list1Input.dataset.productTitle);
      }
    }
    
    if (this.currentList2Selection !== 'list2-base') {
      const list2Input = this.querySelector(`input[value="${this.currentList2Selection}"]`);
      if (list2Input) {
        selections.push(list2Input.dataset.productTitle);
      }
    }
    
    return selections.join(', ') || 'Options de base';
  }

  extractProperties(formData) {
    const properties = {};
    Object.keys(formData).forEach(key => {
      if (key.startsWith('properties[')) {
        const propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = formData[key];
      }
    });
    return properties;
  }

  getMainProductTitle() {
    const titleElement = document.querySelector('.product-meta h1, .product__title, h1');
    return titleElement ? titleElement.textContent.trim() : 'Produit principal';
  }

  // ===== MESSAGES UTILISATEUR =====
  
  showSuccessMessage(message) {
    const successDiv = document.createElement('div');
    successDiv.className = 'product-options__success';
    successDiv.style.cssText = `
      background: #4CAF50; 
      color: white; 
      padding: 12px 20px; 
      border-radius: 8px; 
      margin: 15px 0;
      text-align: center;
      font-weight: 500;
      animation: slideDown 0.3s ease;
      position: relative;
      z-index: 1000;
    `;
    successDiv.textContent = message;
    
    this.insertBefore(successDiv, this.firstChild);
    
    // Supprimer le message après 3 secondes
    setTimeout(() => {
      if (successDiv.parentNode) {
        successDiv.style.animation = 'slideUp 0.3s ease';
        setTimeout(() => successDiv.remove(), 300);
      }
    }, 3000);
  }

  showErrorMessage(message) {
    // Supprimer les anciens messages d'erreur
    const existingErrors = this.querySelectorAll('.product-options__error');
    existingErrors.forEach(error => error.remove());
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'product-options__error';
    errorDiv.style.cssText = `
      background: #ff4444; 
      color: white; 
      padding: 15px 20px; 
      border-radius: 8px; 
      margin: 15px 0;
      text-align: center;
      font-weight: 500;
      animation: slideDown 0.3s ease;
    `;
    errorDiv.textContent = message;
    
    this.insertBefore(errorDiv, this.firstChild);
    
    // Supprimer le message après 6 secondes
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.style.animation = 'slideUp 0.3s ease';
        setTimeout(() => errorDiv.remove(), 300);
      }
    }, 6000);
  }

  // ===== MÉTHODES UTILITAIRES =====

  resetAllSelections() {
    this.currentList1Selection = 'list1-base';
    this.currentList2Selection = 'list2-base';
    
    this.querySelectorAll('input[value="list1-base"], input[value="list2-base"]').forEach(input => {
      input.checked = true;
    });
    
    this.updateTotalPrice();
  }

  getCurrentSelections() {
    return {
      list1: {
        id: this.currentList1Selection,
        element: this.querySelector(`input[value="${this.currentList1Selection}"]`),
        data: this.querySelector(`input[value="${this.currentList1Selection}"]`)?.dataset
      },
      list2: {
        id: this.currentList2Selection,
        element: this.querySelector(`input[value="${this.currentList2Selection}"]`),
        data: this.querySelector(`input[value="${this.currentList2Selection}"]`)?.dataset
      }
    };
  }

  disconnectedCallback() {
    // Nettoyer les event listeners pour éviter les fuites mémoire
    this.querySelectorAll('.product-option-item__input').forEach(input => {
      input.removeEventListener('change', this.handleOptionChange);
    });
    
    this.querySelectorAll('.product-option-item').forEach(item => {
      item.removeEventListener('click', this.handleItemClick);
    });
  }



async updateProductImage(selectedOption, productHandle) {
  try {
    // Récupérer l'URL de l'image actuelle de la variante sélectionnée
    const currentVariant = document.querySelector('input[name="id"][value]');
    if (!currentVariant) return;
    
    // Trouver l'image principale actuelle
    const mainImage = document.querySelector('.product__media-list .product__media-item.is-selected img') ||
                     document.querySelector('.product__media-list .product__media-item img');
    
    if (!mainImage) return;
    
    // 🆕 INITIALISER L'URL DE BASE AU PREMIER APPEL
    if (!this.originalImageUrl) {
      this.originalImageUrl = mainImage.src;
      this.originalImageSrcset = mainImage.srcset || '';
      
      // Nettoyer l'URL de base (retirer les suffixes existants)
      this.baseImageUrl = this.extractBaseImageUrl(this.originalImageUrl);
      
      // console.log('🎯 URLs sauvegardées:', {
      //   originalUrl: this.originalImageUrl,
      //   baseUrl: this.baseImageUrl
      // });
    }
    
    let newImageUrl;
    
    // 🆕 NOUVEAU : Toujours prendre en compte les variantes
    const variants = this.getSelectedVariants();
    
    // 🆕 SI AUCUNE VARIANTE ET AUCUNE OPTION → IMAGE DE BASE PURE
    if (variants.length === 0 && (this.currentList1Selection === 'list1-base' && this.currentList2Selection === 'list2-base')) {
      newImageUrl = this.originalImageUrl;
      this.changeMainImage(newImageUrl, this.originalImageSrcset);
      return;
    }
    
    // 🆕 CONSTRUIRE L'URL AVEC VARIANTES ET/OU OPTIONS
    const allHandles = [];
    
    // 1. Ajouter les variantes (toujours)
    if (variants.length > 0) {
      allHandles.push(...variants);
    }
    
    // 2. Ajouter les options si pas de base
    if (this.currentList1Selection !== 'list1-base') {
      const list1Input = this.querySelector(`input[value="${this.currentList1Selection}"]`);
      const handle1 = list1Input?.dataset.variantHandle || list1Input?.dataset.productHandle;
      if (handle1) allHandles.push(handle1);
    }
    
    if (this.currentList2Selection !== 'list2-base') {
      const list2Input = this.querySelector(`input[value="${this.currentList2Selection}"]`);
      const handle2 = list2Input?.dataset.variantHandle || list2Input?.dataset.productHandle;
      if (handle2) allHandles.push(handle2);
    }
    
    // 3. Si on a des handles, construire l'URL
    if (allHandles.length > 0) {
      const combinedHandle = allHandles.join('-');
      newImageUrl = `${this.baseImageUrl}-${combinedHandle}.jpg`;
      
      // console.log('🖼️ URL construite avec variantes:', {
      //   baseUrl: this.baseImageUrl,
      //   variants: variants,
      //   options: allHandles.slice(variants.length),
      //   combinedHandle: combinedHandle,
      //   finalUrl: newImageUrl
      // });
      console.log('🖼️ URL Finale attendu avec variantes:', {
        finalUrl: newImageUrl
      });
      
      // Tester si la nouvelle image existe
      const imageExists = await this.checkImageExists(newImageUrl);
      
      if (imageExists) {
        this.changeMainImage(newImageUrl);
        console.log('✅ Image changée avec succès');
      } else {
        console.warn('⚠️ Image non trouvée:', newImageUrl);
        
        // 🆕 FALLBACK : Essayer avec seulement les variantes
        if (variants.length > 0) {
          const variantOnlyUrl = `${this.baseImageUrl}-${variants.join('-')}.jpg`;
          
          const variantImageExists = await this.checkImageExists(variantOnlyUrl);
          if (variantImageExists) {
            this.changeMainImage(variantOnlyUrl);
          } else {
            console.warn('⚠️ Image variante non trouvée, conservation de l\'image originale');
            this.changeMainImage(this.originalImageUrl, this.originalImageSrcset);
          }
        } else {
          this.changeMainImage(this.originalImageUrl, this.originalImageSrcset);
        }
      }
    } else {
      // Pas de handles → image originale
      newImageUrl = this.originalImageUrl;
      this.changeMainImage(newImageUrl, this.originalImageSrcset);
    }
    
  } catch (error) {
    console.error('Erreur changement image:', error);
    // En cas d'erreur, revenir à l'image originale
    if (this.originalImageUrl) {
      this.changeMainImage(this.originalImageUrl, this.originalImageSrcset);
    }
  }
}

// 🆕 MÉTHODE POUR EXTRAIRE L'URL DE BASE (sans suffixes)
extractBaseImageUrl(fullUrl) {
  // Retirer les paramètres et l'extension
  const urlParts = fullUrl.split('?')[0].split('.');
  const extension = urlParts.pop(); // Garder l'extension pour plus tard si besoin
  let baseUrl = urlParts.join('.');
  
  // 🎯 PATTERNS COURANTS À RETIRER (adaptez selon vos besoins)
  const suffixPatterns = [
    /-[a-z]+-[a-z]+$/i,     // -noir-mat, -gris-chrome
    /-[a-z]+$/i,            // -noir, -blanc, -gris
    /-\d+m$/i,              // -1m, -2m
    /_\d+x\d+$/i,           // _300x300 (tailles)
    /-v\d+$/i               // -v1, -v2 (versions)
  ];
  
  // Appliquer les patterns pour nettoyer
  // suffixPatterns.forEach(pattern => {
  //   if (pattern.test(baseUrl)) {
  //     const originalBase = baseUrl;
  //     baseUrl = baseUrl.replace(pattern, '');
  //     console.log(`🧹 Nettoyage: "${originalBase}" → "${baseUrl}"`);
  //   }
  // });
  
  return baseUrl;
}

// 🆕 MÉTHODE AMÉLIORÉE POUR CHANGER L'IMAGE
changeMainImage(newUrl, newSrcset = '') {
  const mainImage = document.querySelector('.product__media-list .product__media-item.is-selected img') ||
                   document.querySelector('.product__media-list .product__media-item img');

  if (!mainImage) {
    console.log('🚫 Image principale non trouvée');
    return;
  }
  
  // Animation de transition
  mainImage.style.opacity = '0.7';
  mainImage.style.transition = 'opacity 0.3s ease';
  
  // Précharger la nouvelle image
  const newImg = new Image();
  newImg.onload = () => {
    mainImage.src = newUrl;
    mainImage.srcset = newUrl;
    mainImage.style.opacity = '1';
    
    // Mettre à jour le srcset seulement s'il est fourni
    if (newSrcset) {
      mainImage.srcset = newSrcset;
    }
    
    mainImage.style.opacity = '1';
  };
  
  newImg.onerror = () => {
    console.warn('⚠️ Erreur de chargement:', newUrl);
    mainImage.style.opacity = '1'; // Restaurer l'opacité
  };
  
  newImg.src = newUrl;
}

// 🆕 MÉTHODE DE DEBUG POUR TESTER
debugImageUrls() {
  console.log('🔍 Debug URLs:', {
    originalImageUrl: this.originalImageUrl,
    baseImageUrl: this.baseImageUrl,
    currentSelection: {
      list1: this.currentList1Selection,
      list2: this.currentList2Selection
    }
  });
  
  // Simuler quelques URLs pour test
  const testHandles = ['noir-mat', 'gris-chrome', 'blanc-brillant'];
  testHandles.forEach(handle => {
    const testUrl = `${this.baseImageUrl}-${handle}.jpg`;
    console.log(`Test URL pour "${handle}":`, testUrl);
  });
}

// Vérifier si une image existe
checkImageExists(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}



// Mettre à jour le srcset
updateSrcset(originalSrcset, newBaseUrl) {
  if (!originalSrcset) return '';
  
  const urlParts = newBaseUrl.split('.');
  const extension = urlParts.pop();
  const baseUrl = urlParts.join('.');
  
  return originalSrcset.replace(/https:\/\/[^?\s]+(?=\s|$)/g, (match) => {
    // Extraire la taille de l'URL originale (ex: _300x300)
    const sizeMatch = match.match(/_(\d+x\d+)/);
    const size = sizeMatch ? `_${sizeMatch[1]}` : '';
    return `${baseUrl}${size}.${extension}`;
  });
}

// Identifier l'option de base (présélectionnée initialement)
getBaseOption() {
  // Pour la liste 1
  if (this.isDualLists) {
    return 'list1-base';
  }
  // Pour une liste unique, identifier l'option présélectionnée
  const preselectedInput = this.querySelector('.product-option-item__input:checked');
  return preselectedInput ? preselectedInput.value : null;
}



  // Nouvelle méthode pour récupérer les variantes sélectionnées
getSelectedVariants() {
  const variants = [];
  
  // Méthode 1 : Via les inputs radio sélectionnés
  const selectedInputs = document.querySelectorAll('input[name^="option"]:checked');
  
  selectedInputs.forEach(input => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) {
      let variantValue = label.textContent.trim();
      
      // Nettoyer et convertir en handle
      variantValue = this.convertToHandle(variantValue);
      
      if (variantValue) {
        variants.push(variantValue);
      }
    }
  });
  
  // Méthode 2 : Si pas de résultats, essayer via les spans de valeur
  if (variants.length === 0) {
    
    const valueSpans = document.querySelectorAll('[id*="option"][id*="value"]');
    valueSpans.forEach(span => {
      let variantValue = span.textContent.trim();
      if (variantValue) {
        variantValue = this.convertToHandle(variantValue);
        if (variantValue) {
          variants.push(variantValue);
        }
      }
    });
  }
  
  return variants;
}

// Méthode pour convertir un texte en handle (slug)
convertToHandle(text) {
  return text
    .toLowerCase()
    .replace(/\s+/g, '-')        // Remplacer espaces par tirets
    .replace(/[àáâãäå]/g, 'a')   // Remplacer accents
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[^a-z0-9\-]/g, '')  // Supprimer caractères spéciaux
    .replace(/\-+/g, '-')        // Éviter tirets multiples
    .replace(/^-|-$/g, '');      // Supprimer tirets en début/fin
}

  
  // Nouvelle méthode pour combiner les handles des deux listes
getCombinedHandle() {
  const handles = [];
  
  // 1. AJOUTER LES VARIANTES DU PRODUIT PRINCIPAL
  const variantHandles = this.getSelectedVariants();
  handles.push(...variantHandles);
  
  // 2. Récupérer le handle de la liste 1 si pas base
  if (this.currentList1Selection !== 'list1-base') {
    const list1Input = this.querySelector(`input[value="${this.currentList1Selection}"]`);
    const handle1 = list1Input?.dataset.variantHandle || list1Input?.dataset.productHandle;
    if (handle1) handles.push(handle1);
  }
  
  // 3. Récupérer le handle de la liste 2 si pas base
  if (this.currentList2Selection !== 'list2-base') {
    const list2Input = this.querySelector(`input[value="${this.currentList2Selection}"]`);
    const handle2 = list2Input?.dataset.variantHandle || list2Input?.dataset.productHandle;
    if (handle2) handles.push(handle2);
  }
  
  // Combiner tous les handles avec un tiret
  return handles.length > 0 ? handles.join('-') : null;
}

// Ajouter un event listener pour les changements de variantes
setupVariantListeners() {
  
  // 🆕 SOLUTION : Utiliser la délégation d'événements
  // Au lieu d'écouter chaque input, écouter sur le document
  document.addEventListener('click', (e) => {
    // Vérifier si le clic est sur un input de variante
    if (e.target.matches('input[name="option1"], input[name="option2"], input[name="option3"]')) {
      
      setTimeout(() => {
        this.handleVariantChange();
      }, 100);
      return;
    }
    
    // Ou si le clic est sur un label de variante
    if (e.target.matches('label[for*="option-template"]')) {
      const input = document.getElementById(e.target.getAttribute('for'));
      if (input && input.name.startsWith('option')) {
        
        setTimeout(() => {
          this.handleVariantChange();
        }, 100);
      }
    }
  });
  
  // 🆕 OBSERVER les changements du variant-picker
  const variantPicker = document.querySelector('variant-picker');
  if (variantPicker) {
    
    // Observer TOUS les changements
    const observer = new MutationObserver((mutations) => {
      let hasVariantChange = false;
      
      mutations.forEach((mutation) => {
        // Détecter les changements d'attributs (checked)
        if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
          hasVariantChange = true;
        }
        
        // Détecter les changements de contenu (HTML recréé)
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          hasVariantChange = true;
        }
      });
      
      if (hasVariantChange) {
        setTimeout(() => {
          this.handleVariantChange();
        }, 150);
      }
    });
    
    observer.observe(variantPicker, { 
      attributes: true, 
      attributeFilter: ['checked'],
      childList: true,
      subtree: true
    });
  }
  
  // 🆕 SOLUTION ALTERNATIVE : Écouter les changements sur le script JSON
  const scriptElement = document.querySelector('script[data-variant]');
  if (scriptElement) {
    
    const scriptObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          setTimeout(() => {
            this.handleVariantChange();
          }, 100);
        }
      });
    });
    
    scriptObserver.observe(scriptElement.parentNode, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
}

  handleVariantChange() {
  
  // Récupérer les variantes actuellement sélectionnées
  const variants = this.getSelectedVariants();
  
  // Récupérer les options sélectionnées
  const combinedHandle = this.getCombinedHandle();
  
  // 🆕 AJOUTER CETTE LIGNE : Mettre à jour l'image immédiatement
  this.updateProductImage('variant-change', combinedHandle);
  
  // Émettre l'événement pour le changement d'image
  this.dispatchEvent(new CustomEvent('option-changed', {
    detail: {
      selectedValue: 'variant-change',
      listNumber: 'variant',
      list1Selection: this.currentList1Selection,
      list2Selection: this.currentList2Selection,
      totalPrice: this.calculateTotalPrice(),
      combinedHandle: combinedHandle,
      variants: variants
    },
    bubbles: true
  }));
}

  

debugVariants() {
  console.log('🔍 DEBUG');
}
  
}



// Styles supplémentaires pour les interactions
document.addEventListener('DOMContentLoaded', function() {
  const style = document.createElement('style');
  style.textContent = `
    /* Animation pour le changement de prix */
    .price-list .price {
      transition: all 0.3s ease;
    }
    
    .price-list .price.price--updating {
      transform: scale(1.05);
      color: rgb(var(--color-accent));
    }
    
    /* Loading state pour le bouton d'ajout au panier */
    .product-form__add-button.loading {
      position: relative;
      pointer-events: none;
    }
    
    .product-form__add-button.loading::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      border: 2px solid transparent;
      border-top: 2px solid currentColor;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    
    @keyframes spin {
      to {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }

    /* Animations pour les messages */
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes slideUp {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(-10px);
      }
    }

    /* Messages de succès et d'erreur */
    .product-options__success,
    .product-options__error {
      font-family: inherit;
      line-height: 1.4;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
  `;
  document.head.appendChild(style);
  
  // Gérer les événements globaux
  document.addEventListener('option-changed', function(e) {
    const priceElements = document.querySelectorAll('.price-list .price:not(.price--compare)');
    priceElements.forEach(el => {
      el.classList.add('price--updating');
      setTimeout(() => el.classList.remove('price--updating'), 300);
    });
  });
});

// Utilitaires globaux pour les développeurs
window.ProductOptionsUtils = {
  getAllInstances: () => document.querySelectorAll('product-options-selector'),
  getInstance: (productId) => document.querySelector(`product-options-selector[data-product-id="${productId}"]`),
  resetAll: () => {
    document.querySelectorAll('product-options-selector').forEach(instance => {
      if (instance.resetAllSelections) {
        instance.resetAllSelections();
      }
    });
  },
  getAllSelections: () => {
    const selections = {};
    document.querySelectorAll('product-options-selector').forEach(instance => {
      if (instance.getCurrentSelections) {
        selections[instance.dataset.productId] = instance.getCurrentSelections();
      }
    });
    return selections;
  }
};
